export enum RouterEnum {
    Index = '/',
    login = '/login',
    taskLoading = '/task-loading',
    taskFinished = '/task-finished',
    newsControl = '/news-control',
    // seoNews = '/seo-news',
    FSLogin = '/fs-login',
    FSLoginHandler = '/fs-login-handler',
}